// GENERATED by tools/gen_edge_flags.mjs -- do not edit.
// Scenes the game paints with `skip_edge_textures` set: their cells still
// erase the terrain decal pass under them, but the scene runs no decal pass of
// its own (PixelScene_TryPaintEntry @0x00880fb0). Keys are telescope's
// "dir/name", the same space as VISUAL_OVERLAY_SCENES.
export const SKIP_EDGE_TEXTURE_SCENES = new Set([
	"general/bunker",
	"general/bunker2",
	"general/clean_entrance",
	"general/fishing_hut",
	"general/huussi",
	"overworld/essence_altar",
	"overworld/essence_altar_desert",
	"overworld/snowy_ruins_eye_pillar"
]);

// Biome-map colors (0xRRGGBB) whose biome sets <Topology skip_edge_textures="1">.
// That flag lands in BiomeChunk+0xc7 and gates ONLY the seam-band stamp pass --
// the deferred pass over the cells within 8px of a chunk border. The chunk's
// value is decided by one wobble-resolved biome lookup at the chunk centre, so
// it is a per-chunk decision, not a per-cell one, and the interior dressing
// pass ignores it entirely.
export const SKIP_SEAM_EDGE_BIOMES = new Set([
	0x008080, // mountain_left
	0x018080, // mountain_left_2
	0x028080, // mountain_left_3
	0x085b77, // boss_limbs_arena
	0x204060, // mountain_hall
	0x208080, // mountain_left_entrance
	0x214060, // mountain_hall_2
	0x224060, // mountain_hall_trailer / mountain_hall_3
	0x234060, // mountain_hall_4
	0x364d24, // dragoncave
	0x39401a, // niilo_testroom
	0x39401b, // niilo_testroom_b
	0x39401c, // niilo_testroom_c
	0x39401d, // niilo_testroom_d
	0x3d5a3d, // lavalake
	0x3d5a4f, // lavalake_pit
	0x408080, // mountain_right
	0x4118d6, // lavalake_racing
	0x418080, // mountain_right_entrance
	0x428080, // mountain_right_entrance_2
	0x438080, // mountain_right_2
	0x50eed7, // boss_victoryroom
	0x608080, // mountain_left_stub
	0x7be311, // snowcave_tunnel
	0x9e4302, // robot_egg
	0xc08080, // mountain_top
	0xc08082, // mountain_floating_island
	0xff6a02, // lava
	0xff8080, // mountain_center
	0xffa717, // lava_90percent
]);
